import { render } from "./PlanetryTableFree.vue?vue&type=template&id=455223cf&scoped=true"
import script from "./PlanetryTableFree.vue?vue&type=script&lang=js"
export * from "./PlanetryTableFree.vue?vue&type=script&lang=js"

import "./PlanetryTableFree.vue?vue&type=style&index=0&id=455223cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455223cf"]])

export default __exports__